<template>
  <main>
    <tab-header-customer-id />
    <div class="container">
      <div class="row" v-if="action == '1'">
        <div class="col-12">
          <table class="table table-basic mt-4 mb-4">
            <tr>
              <th class="w-220">設定人員</th>
              <td>{{ UserInfo.name }}</td>
            </tr>
            <tr>
              <th class="w-220"><span style="color: red">*</span>簡覆表編號</th>
              <td>
                <input
                  type="text"
                  maxlength="30"
                  :id="`div-form_no`"
                  :data-vv-name="`div-form_no`"
                  placeholder="請輸入簡覆表編號"
                  v-validate="'required|checkEngNum'"
                  data-vv-as="簡覆表編號"
                  class="form-control w-50"
                  v-model="form.form_no"
                  :class="{ 'is-invalid': errors.has(`div-form_no`) }"
                />
              </td>
            </tr>
            <tr>
              <th class="w-220"><span style="color: red">*</span>客戶ID</th>
              <td>
                <input
                  type="text"
                  maxlength="10"
                  :id="`div-id`"
                  :data-vv-name="`div-id`"
                  placeholder="請輸入客戶ID"
                  v-validate="'required|checkIDLength'"
                  data-vv-as="客戶ID"
                  class="form-control w-50"
                  v-model="form.id"
                  :class="{ 'is-invalid': errors.has(`div-id`) }"
                  @input="checkKeyword('id')"
                  @blur="checkKeyword('id')"
                />
              </td>
            </tr>
            <tr>
              <th class="w-220">異動日期</th>
              <td>{{ moment().getROCDate("YYYY/MM/DD") }}</td>
            </tr>
            <tr>
              <th class="w-220">備註說明</th>
              <td>
                <input
                  type="text"
                  maxlength="50"
                  :id="`div-memo`"
                  :data-vv-name="`div-memo`"
                  placeholder="請輸入備註說明"
                  class="form-control w-50"
                  v-model="form.memo"
                />
              </td>
            </tr>
          </table>
        </div>
        <div class="col-12">
          <div class="action text-right">
            <a class="btn btn-default" @click="doReset(true)">重設</a>
            <a class="btn btn-primary" @click="doQuery">查詢</a>
          </div>
        </div>
      </div>
      <div class="row" v-if="action == '2'">
        <div class="col-12 mt-4">
          <label>【更新客戶資訊(DTMXC111)】</label>
          <table
            id="custinfo_datatable"
            class="table datatable table-striped area-list-datatable mt-4 mb-4"
          >
            <thead>
              <tr>
                <th id="col_AGNT_NAME" class="text-center">業務員姓名</th>
                <th id="col_AGNT_ID" class="text-center">業務員ID</th>
                <th id="col_UPD_KIND" class="text-center">項目</th>
                <th id="col_TEL" class="text-center">電話</th>
                <th id="col_selection" ref="lastCol" class="text-center">
                  勾選
                </th>
              </tr>
            </thead>
            <tbody id="cust-phone-edit-view" v-if="custinfortnList.length > 0">
              <template v-for="(item, index) in custinfortnList">
                <tr :key="`td-custinfortnList-${index}`">
                  <td rowspan="3" class="text-center" style="width:150px">
                    {{ item.emp_name }}
                  </td>
                  <td rowspan="3" class="text-center" style="width:105px">
                    {{ item.agnt_id }}
                  </td>
                  <td class="text-center" style="width:105px">手機號碼</td>
                  <td>
                    <input
                      type="text"
                      v-model="item.mobile"
                      class="form-control w-50"
                      maxlength="20"
                      @input="checkCustInfoNumber(index, 'mobile', 20)"
                      @blur="checkCustInfoNumber(index, 'mobile', 20)"
                    />
                  </td>
                  <td style="width:55px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`CustInfoDataTable-check-${index}`"
                        :value="
                          item.agnt_id +
                          ',MOB,' +
                          transRawCustTel(index, 'MOB') +
                          ',' +
                          transRawCustTel(index, 'MOB', item)
                        "
                        v-model="custinfoselection"
                      />
                      <label :for="`CustInfoDataTable-check-${index}`"></label>
                    </div>
                  </td>
                </tr>
                <tr :key="`td-custinfortnList-${index}-1`">
                  <td class="text-center">住家電話</td>
                  <td class="inline-block">
                    <input
                      type="text"
                      v-model="item.home_tel_area"
                      class="form-control form-control-inline w-15"
                      maxlength="5"
                      @input="checkCustInfoNumber(index, 'home_tel_area', 5)"
                      @blur="checkCustInfoNumber(index, 'home_tel_area', 5)"
                    />
                    -
                    <input
                      type="text"
                      v-model="item.home_tel"
                      class="form-control form-control-inline w-40"
                      maxlength="20"
                      @input="checkCustInfoNumber(index, 'home_tel', 20)"
                      @blur="checkCustInfoNumber(index, 'home_tel', 20)"
                    />
                  </td>
                  <td>
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`CustInfoDataTable-check-${index}-1`"
                        :value="
                          item.agnt_id +
                          ',HOME_TEL,' +
                          transRawCustTel(index, 'HOME') +
                          ',' +
                          transRawCustTel(index, 'HOME', item)
                        "
                        v-model="custinfoselection"
                      />
                      <label
                        :for="`CustInfoDataTable-check-${index}-1`"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr :key="`td-custinfortnList-${index}-2`">
                  <td class="text-center">公司電話</td>
                  <td>
                    <input
                      type="text"
                      v-model="item.corp_tel_area"
                      class="form-control form-control-inline w-15"
                      maxlength="5"
                      @input="checkCustInfoNumber(index, 'corp_tel_area', 5)"
                      @blur="checkCustInfoNumber(index, 'corp_tel_area', 5)"
                    />
                    -
                    <input
                      type="text"
                      v-model="item.corp_tel"
                      class="form-control form-control-inline w-40"
                      maxlength="15"
                      @input="checkCustInfoNumber(index, 'corp_tel', 15)"
                      @blur="checkCustInfoNumber(index, 'corp_tel', 15)"
                    />
                    #
                    <input
                      type="text"
                      v-model="item.corp_tel_ext"
                      class="form-control form-control-inline w-25"
                      maxlength="10"
                      @input="checkCustInfoNumber(index, 'corp_tel_ext', 10)"
                      @blur="checkCustInfoNumber(index, 'corp_tel_ext', 10)"
                    />
                  </td>
                  <td>
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`CustInfoDataTable-check-${index}-2`"
                        :value="
                          item.agnt_id +
                          ',CORP_TEL,' +
                          transRawCustTel(index, 'CORP') +
                          ',' +
                          transRawCustTel(index, 'CORP', item)
                        "
                        v-model="custinfoselection"
                      />
                      <label
                        :for="`CustInfoDataTable-check-${index}-2`"
                      ></label>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="empty">
                  <h3 class="text-center py-5">無任何資料</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 mt-4">
          <label>【更新要保書資料以刪除錯誤聯絡資訊(DTMXC188)】</label>
          <table
            id="insinfo_datatable"
            class="table datatable table-striped area-list-datatable mt-4 mb-4"
          >
            <thead>
              <tr>
                <th id="col_POLICY_NO" class="text-center">保單號碼</th>
                <th id="col_UPD_KIND" class="text-center">項目</th>
                <th id="col_TEL" class="text-center">電話</th>
                <th id="col_selection" ref="lastCol" class="text-center">
                  勾選
                </th>
              </tr>
            </thead>
            <tbody id="ins-phone-edit-view" v-if="insinfortnList.length > 0">
              <template v-for="(item, index) in insinfortnList">
                <tr :key="`td-insinfortnList-${index}`">
                  <td rowspan="2" class="text-center" style="width:150px">
                    {{ item.policy_no }}
                  </td>
                  <td class="text-center" style="width:105px">手機號碼</td>
                  <td>
                    <input
                      type="text"
                      v-model="item.celphone"
                      class="form-control w-50"
                      maxlength="20"
                      @input="checkInsInfoNumber(index, 'celphone', 20)"
                      @blur="checkInsInfoNumber(index, 'celphone', 20)"
                    />
                  </td>
                  <td style="width:55px">
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`InsInfoDataTable-check-${index}`"
                        :value="
                          item.policy_no +
                          ',MOB,' +
                          transRawInsTel(index, 'MOB') +
                          ',' +
                          item.celphone
                        "
                        v-model="insinfoselection"
                      />
                      <label :for="`InsInfoDataTable-check-${index}`"></label>
                    </div>
                  </td>
                </tr>
                <tr :key="`td-insinfortnList-${index}-1`">
                  <td class="text-center">住家電話</td>
                  <td class="inline-block">
                    <input
                      type="text"
                      v-model="item.hometel"
                      class="form-control w-50"
                      maxlength="20"
                      @input="checkInsInfoNumber(index, 'hometel', 20)"
                      @blur="checkInsInfoNumber(index, 'hometel', 20)"
                    />
                  </td>
                  <td>
                    <div class="checkbox checkbox-inline mr-0">
                      <input
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`InsInfoDataTable-check-${index}-1`"
                        :value="
                          item.policy_no +
                          ',HOME_TEL,' +
                          transRawInsTel(index, 'HOME') +
                          ',' +
                          item.hometel
                        "
                        v-model="insinfoselection"
                      />
                      <label
                        :for="`InsInfoDataTable-check-${index}-1`"
                      ></label>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="empty">
                  <h3 class="text-center py-5">無任何資料</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12">
          <div class="action text-right">
            <a class="btn btn-default" @click="previous()">取消</a>
            <a class="btn btn-primary" @click="doSubmit">確定</a>
          </div>
        </div>
      </div>
      <!-- 打開遮罩 -->
      <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { Validator } from "vee-validate";
//component
import TabHeaderCustomerId from "@/desktop/components/backend/TabHeaderCustomerId";
import mxMask from "@/desktop/components/mxMask";
//service
import { queryCustTel, updateCustTel } from "@/service";
export default {
  name: "CustTelChange",
  mixins: [commonMixin],
  components: {
    TabHeaderCustomerId,
    mxMask,
  },
  computed: {
    ...mapGetters(["UserInfo"]),
  },
  watch: {},
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: "資料查詢中，請稍候...",
      form: {
        form_no: "", // 簡覆表編號
        id: "", // 客戶ID
        memo: "", // 備註說明
      },
      action: "1",
      custinfortnList: [], //更新客戶資訊顯示資料
      RAWcustinfortnList: [], //更新客戶資訊顯示資料(原始)
      insinfortnList: [], //更新要保書顯示資料
      custinfoselection: [],
      insinfoselection: [],
    };
  },
  mounted() {
    this.initValidator();
    this.action = "1";
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //監聽input 只能輸入數字 及長度檢核
    checkCustInfoNumber(index, col, maxlen) {
      this.custinfortnList[index][col] = this.custinfortnList[index][
        col
      ].replace(/[^\d]/g, "");
      if (
        this.stringBytes(this.custinfortnList[index][col], false, maxlen) >
        maxlen
      ) {
        this.custinfortnList[index][col] = this.custinfortnList[index][
          col
        ].substring(
          0,
          this.stringBytes(this.custinfortnList[index][col], true, maxlen)
        );
      }
      this.custinfoselection = [];
    },

    //監聽input 只能輸入數字 及長度檢核
    checkInsInfoNumber(index, col, maxlen) {
      this.insinfortnList[index][col] = this.insinfortnList[index][col].replace(
        /[^\d]/g,
        ""
      );
      if (
        this.stringBytes(this.insinfortnList[index][col], false, maxlen) >
        maxlen
      ) {
        this.insinfortnList[index][col] = this.insinfortnList[index][
          col
        ].substring(
          0,
          this.stringBytes(this.insinfortnList[index][col], true, maxlen)
        );
      }
      this.insinfoselection = [];
    },

    //檢核ID
    checkKeyword(id) {
      if (this.form[id]) {
        this.form[id] = this.form[id].toUpperCase();
        this.form[id] = this.form[id].replace(/[^a-zA-Z0-9]+/g, "");
      }
      if (this.stringBytes(this.form[id], false, 10) > 10) {
        this.form[id] = this.form[id].substring(
          0,
          this.stringBytes(this.form[id], true, 10)
        );
      }
    },

    //串組原始值
    transRawCustTel(index, type, data) {
      let temp_data = this.RAWcustinfortnList[index];
      if (data) {
        temp_data = data;
      }
      let area, tel, ext;
      switch (type) {
        case "MOB":
          tel = temp_data.mobile;
          break;
        case "HOME":
          area = temp_data.home_tel_area;
          tel = temp_data.home_tel;
          break;
        case "CORP":
          area = temp_data.corp_tel_area;
          tel = temp_data.corp_tel;
          ext = temp_data.corp_tel_ext;
      }
      let temp_tel = "";
      if (area) {
        temp_tel += area + "-";
      }
      if (tel) {
        temp_tel += tel;
      }
      if (ext) {
        temp_tel += "#" + ext;
      }
      return temp_tel;
    },
    //串組原始值
    transRawInsTel(index, type) {
      const temp_data = this.RAWinsinfortnList[index];
      switch (type) {
        case "MOB":
          return temp_data.celphone || "";
        case "HOME":
          return temp_data.hometel || "";
      }
    },
    //重設
    doReset(showMsg) {
      this.form = {
        form_no: "", // 簡覆表編號
        id: "", // 客戶ID
        memo: "", // 備註說明
      };
      if (showMsg) {
        this.$toast.info({ title: "畫面重設成功" });
      }
    },
    //查詢
    doQuery() {
      //檢核
      this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
        } else {
          this.callApi();
        }
      });
    },
    //取消
    previous() {
      this.action = "1";
    },
    //確定
    doSubmit() {
      if (
        this.custinfoselection.length > 0 ||
        this.insinfoselection.length > 0
      ) {
        const reqData = {
          id: this.form.id.trim(), // 客戶ID
          form_no: this.form.form_no.trim(), // 簡覆表編號
          memo: this.form.memo, // 備註說明
          custinfo: this.custinfoselection, // 更新客戶資訊
          insinfo: this.insinfoselection, // 更新要保書
        };
        this.mxMaskOpen = true;
        updateCustTel(reqData).then((result) => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "電話異動成功" });
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      } else {
        this.$toast.info({ title: "尚未勾選異動資料" });
      }
    },
    callApi() {
      const reqData = {
        id: this.form.id.trim(), // 客戶ID
      };
      this.mxMaskOpen = true;
      queryCustTel(reqData).then((result) => {
        this.mxMaskOpen = false;
        if (result.header && result.header.status == "200") {
          this.RAWcustinfortnList = JSON.parse(
            JSON.stringify(result.body.custinfo)
          );
          this.custinfortnList = result.body.custinfo;
          this.RAWinsinfortnList = JSON.parse(
            JSON.stringify(result.body.insinfo)
          );
          this.insinfortnList = result.body.insinfo;
          this.action = "2";
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });

      this.$validator.reset();
    },
    initValidator() {
      // 初始自訂義檢核
      Validator.extend("checkEngNum", {
        getMessage: (field) => {
          return `${field}不可輸入英文、數字以外內容`;
        },
        validate: (value) => {
          let isNonEmpty = value.trim().length > 0;
          let isFormatCurrect = /^[a-zA-Z0-9\\]*$/.test(value);
          return isNonEmpty && isFormatCurrect;
        },
      });

      // 初始自訂義檢核
      Validator.extend("checkIDLength", {
        getMessage: (field) => {
          return `${field}長度不可少於10碼`;
        },
        validate: (value) => {
          return value.trim().length == 10;
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.w-15 {
  width: 15% !important;
}

.w-40 {
  width: 40% !important;
}
</style>
